/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_MicrosoftInputs */



/**
* | output |
* | --- |
* | "Continue with Microsoft" |
*
* @param {Invite_X15_MicrosoftInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_microsoft = /** @type {((inputs?: Invite_X15_MicrosoftInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_MicrosoftInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Continue with Microsoft")
});